import moment from "moment";

export enum TimePeriod {
  All = "All",
  LastYear = "LastYear",
  YTD = "YTD",
  LastMonth = "LastMonth",
  ThisMonth = "ThisMonth",
  Today = "Today",
  Custom = "Custom",
}

type Props = {
  period: TimePeriod | null;
  from: Date | null;
  to: Date | null;
};

export const useDetectTimePeriod = (props: Props | null) => {
  if (!props || !props.period || props.period === TimePeriod.All) {
    return { from: null, to: null };
  }

  const { period, from, to } = props;

  if (period === TimePeriod.LastYear) {
    return {
      from: moment().startOf("D").subtract(1, "y").toDate(),
      to: moment().endOf("D").toDate(),
    };
  }

  if (period === TimePeriod.YTD) {
    return {
      from: moment().startOf("D").startOf("y").toDate(),
      to: moment().endOf("D").toDate(),
    };
  }

  if (period === TimePeriod.LastMonth) {
    return {
      from: moment().startOf("D").subtract(1, "M").startOf("M").toDate(),
      to: moment().startOf("D").subtract(1, "M").endOf("M").toDate(),
    };
  }

  if (period === TimePeriod.ThisMonth) {
    return {
      from: moment().startOf("D").startOf("M").toDate(),
      to: moment().endOf("M").toDate(),
    };
  }

  if (period === TimePeriod.Today) {
    return {
      from: moment().startOf("D").toDate(),
      to: moment().endOf("D").toDate(),
    };
  }

  if (from && to) {
    return {
      from,
      to,
    };
  }

  return {
    from: moment(from || new Date())
      .startOf("D")
      .toDate(),
    to: moment(to || new Date())
      .endOf("D")
      .toDate(),
  };
};
